import { device } from '../../../constants/StyledComponentConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UsageTracker from '../../../utils/UsageTracker';
import ResponsiveCardGridContainer from '../../../components/ResponsiveCardGridContainer';
import SectionHeading from '../../../components/SectionHeading';
import { RouterLink } from '../../../components/AcademyLinks';
import styled, { css, mediaQuery, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { NavMarker } from 'react-rhumb';
import { useMyLearningCardModels } from '../../myLearning/myLearningQueries';
import { MyLearningTabTypeToRequestMapping } from '../../myLearning/myLearningConsts';
import LearningContentCard from '../../cards/components/LearningContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE = 3;
const InProgressContainer = styled.div.withConfig({
  displayName: "InProgressSection__InProgressContainer",
  componentId: "dzs6qe-0"
})(["padding:35px 0 40px;border-bottom:1px solid ", ";@media screen and ", "{padding:16px 0 20px;}"], GREAT_WHITE, device.mobile);
const PaddedRouterLink = styled(RouterLink).withConfig({
  displayName: "InProgressSection__PaddedRouterLink",
  componentId: "dzs6qe-1"
})(["padding:12px 0;"]);
const HeaderContainer = styled(UIFlex).withConfig({
  displayName: "InProgressSection__HeaderContainer",
  componentId: "dzs6qe-2"
})(["margin-bottom:16px;", ""], mediaQuery('mobile', css(["margin-bottom:8px;"])));
const CardBox = styled.div.withConfig({
  displayName: "InProgressSection__CardBox",
  componentId: "dzs6qe-3"
})(["width:100%;padding:4px 0;&:not(:last-child){@media screen and ", "{margin-right:32px;flex-basis:auto;}}"], device.mobile);
const useInProgressSection = () => {
  const {
    myLearningCardModels: inProgressItems,
    myLearningCardModelsLoading: inProgressItemsLoading,
    myLearningCardModelsError: inProgressItemsError,
    totalCount
  } = useMyLearningCardModels({
    contentTypes: MyLearningTabTypeToRequestMapping['all'],
    offset: {
      cursor: 0
    },
    pageLength: PAGE_SIZE,
    progressType: 'IN_PROGRESS',
    includePlaylistProgress: true
  });
  return {
    inProgressItems,
    inProgressItemsLoading,
    inProgressItemsError,
    totalCount
  };
};
const ViewAllLink = () => {
  const {
    isMobile
  } = useMediaQuery();
  const trackViewAllClick = () => UsageTracker.track('interaction', {
    action: 'in-progress-view-all-clicked'
  });
  return /*#__PURE__*/_jsx(PaddedRouterLink, {
    onClick: trackViewAllClick,
    to: "/mylearning",
    children: isMobile ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.inProgressSection.seeAll`
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.inProgressSection.viewAll`
    })
  });
};
export const InProgressSection = () => {
  const {
    inProgressItems,
    inProgressItemsError,
    inProgressItemsLoading,
    totalCount
  } = useInProgressSection();
  if (inProgressItemsLoading || inProgressItemsError || !(inProgressItems !== null && inProgressItems !== void 0 && inProgressItems.length)) return null;
  const showViewMoreLink = totalCount > PAGE_SIZE;
  return /*#__PURE__*/_jsxs(InProgressContainer, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_INPROGRESS_LOADED"
    }), /*#__PURE__*/_jsxs(HeaderContainer, {
      align: 'center',
      children: [/*#__PURE__*/_jsx(UIBox, {
        grow: 2,
        children: /*#__PURE__*/_jsx(SectionHeading, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.inProgressSection.sectionTitle"
          })
        })
      }), showViewMoreLink && /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(ViewAllLink, {})
      })]
    }), /*#__PURE__*/_jsx(ResponsiveCardGridContainer, {
      className: 'noBorder noPadding',
      columnSize: 250,
      columns: 3,
      nowrap: true,
      children: inProgressItems.map(item => /*#__PURE__*/_jsx(CardBox, {
        children: /*#__PURE__*/_jsx(LearningContentCard, {
          item: item,
          overviewType: "my-learning",
          size: "small"
        })
      }, `item_progress_${item.id}`))
    })]
  });
};
export default InProgressSection;